import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  CenterContainer,
  RegisterContainer,
  RegisterContainerHeader,
  InputField,
  LabelInput,
  FieldElement,
  RegisterButton,
} from "./styles";
import { useAuth } from "../../contexts/AuthContext";

const RegisterPageContent = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("Unable to register account");
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const { signUp } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email && password) {
      // signUp(email, password).then(() => {
      //   navigate("/budget", { replace: true });
      // });

      signUp(email, password).then(() => {
        setShowError(false);
        navigate("/budget", { replace: true });
      }).catch((err) => {
        setShowError(true);
        console.log(err);
      });
    }

    console.log("submit");
  };

  return (
    <CenterContainer>
      <RegisterContainer>
        <RegisterContainerHeader>Register Page</RegisterContainerHeader>
        {showError ? (<><div className="alert alert-danger" role="alert">
          {errorMsg}
        </div></>) : null}
        <form onSubmit={handleSubmit}>
          <FieldElement>
            <LabelInput htmlFor="email">Email</LabelInput>
            <InputField
              autoComplete="on"
              value={email}
              type="email"
              name="email"
              id="email"
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FieldElement>

          <FieldElement>
            <LabelInput htmlFor="password">Password</LabelInput>
            <InputField
              autoComplete="on"
              value={password}
              type="password"
              name="password"
              id="password"
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </FieldElement>

          <RegisterButton type="submit">Register</RegisterButton>
        </form>
      </RegisterContainer>
    </CenterContainer>
  );
};

export default RegisterPageContent;
